import TnAvatar from './TnAvatar';

export type { AvatarURLDetail } from './TnAvatar';
export { TnAvatar };
